import $http from '$http';
import {
    cloneDeep,
    util,
    isCorrectVal,
    isDate,
    lg
} from 'utils';
import {
    GetProvinces,
    GetCitys,
    GetAreas,
    GetAgentList,
    GetParmConfig, //寄送，支付接口
    GetProductClass,
    GetAgentConsigneeList,
    Consignee_Add,
    GetEmployList,
    ConsigneeSetDefault
} from '@api/commonApi.js';
export default {
    methods: {
        /*支付，寄送*/
        // getPay(type) {
        //     let Params = {
        //         Sid: this.$store.state.sysSid,
        //         Session: this.$store.state.sysSession,
        //         ParmType: type
        //     }
        //     GetParmConfig(Params).then(res => {
        //         util.doResult(this, res, () => {
        //             if (type == 9) {
        //                 this.PayList = res.data.Data;
        //             } else {
        //                 this.transportList = res.data.Data;
        //             }

        //         });
        //     });
        // },
        // 获取收货地址
        getAgentConsigneeList(id) {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                AgentId: id,
                CustomerId: 0
            };
            this.loading = true;
            $http.get("api/Common/GetAgentConsigneeList", params).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                this.loading = false;
                util.doResult(this, res, () => {
                    this.AddressList = Data;
                    for (let i = 0; i < this.AddressList.length; i++) {
                        //IsDefault==1为默认地址
                        if (this.AddressList[i].IsDefault == 1) {
                            this.ConsigneeList = this.AddressList[i].Address
                            this.ConsigneeListName = this.AddressList[i].Consignee + '  ' + this.AddressList[i].ConsigneeTel
                            this.form.ConsigneeId = this.AddressList[i].Id

                        }
                    }
                });
            });
        },
        //新增销售下单
        getAddOrderList() {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
            };
            this.loading = true;

            $http.post("api/BookOnlyOrder/BookOnlyAdd", Object.assign({}, params, this.form)).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                this.loading = false;
                util.doResult(this, res, () => {
                    this.$notify({
                        title: '成功',
                        message: '下单成功',
                        type: 'success'
                    });
                    this.$emit('getTableList')
                    this.AddDialogVisible = false

                });
            });
        },
        //修改订单
        getUpdateOrderList() {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
            };
            this.loading = true;

            $http.post("api/BookOnlyOrder/BookOnlyOrderUpdate", Object.assign({}, params, this.form)).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                this.loading = false;
                util.doResult(this, res, () => {
                    this.$notify({
                        title: '成功',
                        message: '修改成功',
                        type: 'success'
                    });

                    this.AddDialogVisible = false
                });
            });
        },
        // 查看/修改
        getList() {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                OrderId: this.showData.OrderId
            };
            this.loading = true;
            $http.get("api/BookOnlyOrder/GetBookOnlyOrderById", params).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                this.loading = false;
                util.doResult(this, res, () => {
                    this.form = util.filterAndSetData(this.form, Data) //过滤数据
                    this.form.OrderId = Data.OrderId
                    // 代理商主联系人，代理商公司，代理商所在区域，代理商联系电话
                    this.agent = Data.C_Name + '  ' + Data.AgentName + '  ' + Data.ShortAddress + '  ' + Data.C_Tel
                    this.ConsigneeList = Data.ProvName + '  ' + Data.CityName + '  ' + Data.AreaName + '  ' + Data.Address
                    this.ConsigneeListName = Data.Consignee + '  ' + Data.ConsigneeTel
                    this.form.ConsigneeId = Data.AgentConsigneeId
                    this.getAgentBookOrderHistory(this.form.AgentId, this.showData.OrderId)
                });
            });
        },
        //获取代理商列表
        getAgentList(agentId) {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                pageIndex: this.pageIndex,
                pageSize: this.pageSize,
                agentLevel: 2,
                AgentId: agentId,
                agentType: 1 //智趣坞下单用
            };

            this.loading = true;
            $http.get("api/Common/GetAgentList", params).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                this.loading = false;
                util.doResult(this, res, () => {
                    this.agent = Data[0].Customer + '   ' + Data[0].Address + '   ' + Data[0].AgentTel
                });
            });
        },
        //获取代理商已下订单信息
        getAgentBookOrderHistory(agentId, OrderId) {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                AgentId: agentId,
                OrderId: OrderId
            };
            this.details = {}
            this.loading = true;
            $http.get("api/BookOnlyOrder/GetAgentBookOrderHistory", params).then(res => {
                let {
                    Data,
                    Cnt
                } = res.data;
                this.loading = false;
                util.doResult(this, res, () => {
                    this.details = Data;
                    this.details.area = []
                    for (let i = 0; i < this.details.AreaList.length; i++) {
                        this.details.area.push(this.details.AreaList[i].ProvName + this.details.AreaList[i].CityName + this.details.AreaList[i].AreaName)

                    }
                    this.details.area = this.details.area.join(',')
                    // 判断
                    // if (this.details.ProNum >= this.details.FirstGoodsNum) {
                    //     this.$notify({
                    //         title: '警告',
                    //         message: '该代理商的订货量已全部订购，无法继续下单,请重新选择代理商',
                    //         type: 'warning'
                    //     });
                    // }
                    // else if (this.details.ContractMoney == 0) {
                    //     this.$notify({
                    //         title: '警告',
                    //         message: '该代理商合同预付款为0，无法继续下单,请重新选择代理商',
                    //         type: 'warning'
                    //     });
                    // }
                });
            });
        },
    }
}


// WEBPACK FOOTER //
// ./src/pages/Order/zqwOrder/addSellingOrder/services.js